var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6942 12.633C14.4616 12.633 15.8943 11.2003 15.8943 9.43291C15.8943 7.66555 14.4616 6.23282 12.6942 6.23282C10.9269 6.23282 9.49414 7.66555 9.49414 9.43291C9.49414 11.2003 10.9269 12.633 12.6942 12.633Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6457 9.1609C23.7047 6.72695 22.0712 4.62207 19.947 3.1064C17.8228 1.59073 15.301 0.730721 12.6934 0.63266C10.0857 0.730721 7.56392 1.59073 5.43971 3.1064C3.31551 4.62207 1.68198 6.72695 0.74102 9.1609C0.677472 9.33667 0.677472 9.52915 0.74102 9.70492C1.68198 12.1389 3.31551 14.2438 5.43971 15.7594C7.56392 17.2751 10.0857 18.1351 12.6934 18.2332C15.301 18.1351 17.8228 17.2751 19.947 15.7594C22.0712 14.2438 23.7047 12.1389 24.6457 9.70492C24.7092 9.52915 24.7092 9.33667 24.6457 9.1609V9.1609ZM12.6934 14.6331C11.6649 14.6331 10.6595 14.3281 9.80431 13.7567C8.94915 13.1853 8.28264 12.3731 7.88905 11.4229C7.49546 10.4727 7.39248 9.42714 7.59313 8.41841C7.79378 7.40968 8.28905 6.4831 9.0163 5.75585C9.74355 5.0286 10.6701 4.53333 11.6789 4.33268C12.6876 4.13203 13.7332 4.23501 14.6834 4.6286C15.6336 5.02219 16.4457 5.6887 17.0171 6.54386C17.5885 7.39902 17.8935 8.40442 17.8935 9.43291C17.8914 10.8114 17.3428 12.1329 16.3681 13.1076C15.3933 14.0824 14.0719 14.6309 12.6934 14.6331V14.6331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWhite);
export default __webpack_public_path__ + "static/media/eye-white.dba1d4411bc1d21505a7140065d42548.svg";
export { ForwardRef as ReactComponent };